const DEFAULT_REDIRECT = '/projects/list';

function getRouterBasename() {
  const raw = process.env.REACT_APP_ROUTER_BASENAME;
  if (raw == null || raw === '' || raw === '/') {
    return '/';
  }
  const withSlash = raw.startsWith('/') ? raw : `/${raw}`;
  return withSlash.endsWith('/') ? withSlash.slice(0, -1) : withSlash;
}

function stripBasename(pathname) {
  const basename = getRouterBasename();
  if (basename === '/' || !pathname.startsWith(basename)) {
    return pathname;
  }
  const stripped = pathname.slice(basename.length);
  return stripped || '/';
}

/**
 * Reads and clears localStorage.from, returning a router-relative path
 * (basename stripped) for post-login redirect.
 */
export function getPostLoginRedirectPath() {
  const savedUrl = window.localStorage.getItem('from');
  if (!savedUrl) {
    return DEFAULT_REDIRECT;
  }

  window.localStorage.removeItem('from');

  try {
    const decoded = decodeURIComponent(savedUrl);
    if (decoded.startsWith('http')) {
      const url = new URL(decoded);
      return stripBasename(url.pathname + url.search);
    }
    return stripBasename(decoded);
  } catch (e) {
    return DEFAULT_REDIRECT;
  }
}
